export enum EtlBookingTypeEnum {
  flight = "flight",
  sightseeing = "sight",
  game = "game",
  training = "training",
}
